import { render } from "./CalculadoraFirePage.vue?vue&type=template&id=9b923136"
import script from "./CalculadoraFirePage.vue?vue&type=script&lang=js"
export * from "./CalculadoraFirePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__